import { Reveal, Eyebrow } from "./Reveal";
import { BookingForm } from "./BookingForm";

const STEPS = [
  ["Anfrage ausfüllen", "Name, E-Mail und gern deinen Wunschtermin."],
  ["E-Mail senden", "Dein E-Mail-Programm öffnet sich mit der fertigen Nachricht."],
  ["Persönliche Rückmeldung", "Ich melde mich bei dir und wir stimmen den Termin ab."],
];

export const Booking = ({ preselect, onOpenPrivacy }) => (
  <section id="termin" data-testid="booking-section" className="relative bg-champagne py-24 lg:py-36">
    <div className="mx-auto grid max-w-7xl gap-14 px-5 sm:px-8 lg:grid-cols-[0.8fr_1.2fr] lg:gap-20">
      <div className="lg:sticky lg:top-28 lg:self-start">
        <Reveal>
          <Eyebrow index="03">Terminanfrage</Eyebrow>
          <h2 className="mt-6 font-serif text-4xl leading-[1.05] text-ink sm:text-5xl lg:text-6xl">
            Dein Moment <span className="italic text-gold-deep">für dich.</span>
          </h2>
          <p className="mt-6 max-w-sm text-[15px] leading-relaxed text-ink-soft">
            Ganz unkompliziert per E-Mail – ohne Registrierung, ohne Konto.
          </p>
        </Reveal>
        <ol className="mt-10 space-y-6">
          {STEPS.map(([title, text], i) => (
            <Reveal as="li" key={title} delay={0.1 + i * 0.08} className="flex gap-5">
              <span className="font-serif text-3xl italic leading-none text-gold">{i + 1}</span>
              <div>
                <p className="font-serif text-xl text-ink">{title}</p>
                <p className="mt-1 text-sm text-ink-soft">{text}</p>
              </div>
            </Reveal>
          ))}
        </ol>
      </div>
      <Reveal delay={0.1} className="scroll-mt-24 rounded-[32px] border border-gold/30 bg-paper p-6 shadow-[0_30px_80px_rgba(45,36,30,0.08)] sm:p-10 lg:p-12">
        <div id="termin-formular" />
        <BookingForm preselect={preselect} onOpenPrivacy={onOpenPrivacy} />
      </Reveal>
    </div>
  </section>
);
